import React, { useCallback } from 'react'

import { InputField } from '../../../../../../common/components/input/InputField'
import styles from './Footer.module.css'

type FooterProps = {
  value: string | undefined
  onChangeMessage: (message: string) => void
  onSubmit: (e: React.SyntheticEvent<HTMLFormElement>) => void
}

export const Footer: React.FC<FooterProps> = ({ value = '', onChangeMessage, onSubmit }) => {
  const onChangeMessageInternal = useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget
      onChangeMessage(value)
    },
    [onChangeMessage],
  )

  return (
    <div className={styles.container}>
      <form className={styles.messageInputForm} onSubmit={onSubmit}>
        <InputField
          required
          name='message-field'
          onChange={onChangeMessageInternal}
          value={value}
          button={{
            type: 'submit',
          }}
        />
      </form>
    </div>
  )
}
